import { T } from '@tribeplatform/react-components/i18n'

import { DefaultSpacesSettings } from '../DefaultSpacesSettings.js'

export function CommunityDefaultSpacesSettingsRouter() {
  return <DefaultSpacesSettings />
}

export function CommunityDefaultSpacesSettingsBreadCrumb() {
  return <T id="Settings.DefaultSpaces" defaultMessage="Default Spaces" />
}
